import * as React from "react";
const PaperPlane = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={13} {...props}>
    <path d="M14.453 5.457 2.203.207a.728.728 0 0 0-.328-.082c-.246 0-.492.082-.656.273a.917.917 0 0 0-.137 1.012l2.543 4.84-2.543 4.867c-.164.328-.11.738.137.985.164.191.41.3.656.3.11 0 .219-.027.328-.082l12.25-5.25A.896.896 0 0 0 15 6.25c-.027-.328-.219-.656-.547-.793ZM2.805 1.902l8.668 3.692H4.746L2.805 1.902Zm1.941 5.004h6.727l-8.668 3.719 1.941-3.719Z" />
  </svg>
);
export default PaperPlane;
